import { render, staticRenderFns } from "./datasource.vue?vue&type=template&id=8af6d92e&scoped=true&"
import script from "./datasource.vue?vue&type=script&lang=js&"
export * from "./datasource.vue?vue&type=script&lang=js&"
import style0 from "./datasource.vue?vue&type=style&index=0&id=8af6d92e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af6d92e",
  null
  
)

export default component.exports